export default "__VITE_ASSET__BEKOfahd__";